import { useDateFormatter } from '@react-aria/i18n'
import CopyButton from 'components/Hero/CopyButton'
import { useEffect, useState } from 'react'
import { formatDuration } from '../utils/formatCallDuration'

export function CallRow({ call, onCopy, onTranscriptView, isActive }) {
  const [currentDuration, setCurrentDuration] = useState(
    call.status === 'IN_PROGRESS' ? formatDuration(call.timestamp) : '0:00',
  )

  useEffect(() => {
    let intervalId

    if (call.status === 'IN_PROGRESS') {
      intervalId = setInterval(() => {
        setCurrentDuration(formatDuration(call.timestamp))
      }, 1000)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [call.status, call.timestamp])

  const formatter = useDateFormatter({ dateStyle: 'short', timeStyle: 'short' })

  return (
    <tr
      className={`border-b border-gray-100 cursor-pointer transition-colors duration-200 
      ${isActive ? 'bg-indigo-50/80' : 'hover:bg-gray-50'}`}
      onClick={() => onTranscriptView(call.call_id)}
    >
      <td className="px-4 py-2.5">
        <CopyButton
          value={call.call_id}
          displayText={call.call_id}
          color="default"
        />
      </td>
      <td className="px-4 py-2.5 text-xs">

        <span className="flex items-center">
          <span
            className={`px-1.5 py-0.5 rounded-full text-2xs font-semibold ${
              call.status === 'IN_PROGRESS'
                ? 'bg-indigo-100 text-indigo-800'
                : call.status === 'QUEUED'
                  ? 'bg-yellow-100 text-yellow-800'
                  : call.status === 'COMPLETE'
                    ? 'bg-green-100 text-green-800'
                    : 'bg-gray-100 text-gray-800'
            }`}
          >
            {call.start_time ? `SCHEDULED (${formatter.format(new Date(call.start_time))})` : call.status}
          </span>
        </span>
      </td>
      <td className="px-4 py-2.5 text-xs text-gray-600">{currentDuration}</td>
      <td className="px-4 py-2.5 text-xs text-gray-600">{call.from}</td>
      <td className="px-4 py-2.5 text-xs text-gray-600">{call.to}</td>
      <td className="px-4 py-2.5 text-xs text-gray-600">
        {call.objective
          ? (
              <span title={call.objective}>
                {call.objective.length > 50
                  ? `${call.objective.slice(0, 50)}...`
                  : call.objective}
              </span>
            )
          : (
              'N/A'
            )}
      </td>
      <td className="px-4 py-2.5 text-xs">
        <button
          onClick={() => onTranscriptView(call.call_id)}
          className="text-blue-600 hover:text-blue-800"
        >
          View Transcript
        </button>
      </td>
    </tr>
  )
}

CallRow.displayName = 'CallRow'
